import {useMemo} from 'react';

import {Margin} from '../commons/types';
import {X_AXIS_HEIGHT} from '../components/axis/xAxis';
import {yAxisWidth} from '../components/axis/yAxis';

export const useMaxInRange = (
  width: number,
  height: number,
  margin: Margin = {},
  hasYAxis = false,
  hasXAxis = false,
) =>
  useMemo(
    () => [
      width - (margin.left || 0) - (margin.right || 0) - (hasYAxis ? yAxisWidth : 0),
      height - (margin.top || 0) - (margin.bottom || 0) - (hasXAxis ? X_AXIS_HEIGHT : 0),
    ],
    [width, height, margin, hasXAxis, hasYAxis],
  );
